!function (e, t) {
  "object" === typeof exports && "object" === typeof module ? module.exports = t() : "function" === typeof define && define.amd ? define([], t) : "object" === typeof exports ? exports.Button = t() : e.Button = t();
}(this, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/", n(n.s = 15);
  }([function (e, t, n) {
    "use strict";

    e.exports = n(16);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e["default"] : e;
    }

    t.__esModule = !0;
    var o = n(18);
    t.Motion = r(o);
    var a = n(23);
    t.StaggeredMotion = r(a);
    var u = n(24);
    t.TransitionMotion = r(u);
    var i = n(26);
    t.spring = r(i);
    var l = n(13);
    t.presets = r(l);
    var c = n(2);
    t.stripStyle = r(c);
    var s = n(27);
    t.reorderKeys = r(s);
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function (e) {
      var t = {};

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = "number" === typeof e[n] ? e[n] : e[n].val);
      }

      return t;
    }, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function (e) {
      var t = {};

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = 0);
      }

      return t;
    }, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function (e, t, n, o, a, u, i) {
      var l = n + (-a * (t - o) + -u * n) * e,
          c = t + l * e;
      if (Math.abs(l) < i && Math.abs(c - o) < i) return r[0] = o, r[1] = 0, r;
      return r[0] = c, r[1] = l, r;
    };
    var r = [0, 0];
    e.exports = t["default"];
  }, function (e, t, n) {
    (function (t) {
      (function () {
        var n, r, o;
        "undefined" !== typeof performance && null !== performance && performance.now ? e.exports = function () {
          return performance.now();
        } : "undefined" !== typeof t && null !== t && t.hrtime ? (e.exports = function () {
          return (n() - o) / 1e6;
        }, r = t.hrtime, o = (n = function n() {
          var e;
          return 1e9 * (e = r())[0] + e[1];
        })()) : Date.now ? (e.exports = function () {
          return Date.now() - o;
        }, o = Date.now()) : (e.exports = function () {
          return new Date().getTime() - o;
        }, o = new Date().getTime());
      }).call(this);
    }).call(this, n(12));
  }, function (e, t, n) {
    (function (t) {
      for (var r = n(20), o = "undefined" === typeof window ? t : window, a = ["moz", "webkit"], u = "AnimationFrame", i = o["request" + u], l = o["cancel" + u] || o["cancelRequest" + u], c = 0; !i && c < a.length; c++) {
        i = o[a[c] + "Request" + u], l = o[a[c] + "Cancel" + u] || o[a[c] + "CancelRequest" + u];
      }

      if (!i || !l) {
        var s = 0,
            f = 0,
            p = [];
        i = function i(e) {
          if (0 === p.length) {
            var t = r(),
                n = Math.max(0, 1e3 / 60 - (t - s));
            s = n + t, setTimeout(function () {
              var e = p.slice(0);
              p.length = 0;

              for (var t = 0; t < e.length; t++) {
                if (!e[t].cancelled) try {
                  e[t].callback(s);
                } catch (n) {
                  setTimeout(function () {
                    throw n;
                  }, 0);
                }
              }
            }, Math.round(n));
          }

          return p.push({
            handle: ++f,
            callback: e,
            cancelled: !1
          }), f;
        }, l = function l(e) {
          for (var t = 0; t < p.length; t++) {
            p[t].handle === e && (p[t].cancelled = !0);
          }
        };
      }

      e.exports = function (e) {
        return i.call(o, e);
      }, e.exports.cancel = function () {
        l.apply(o, arguments);
      }, e.exports.polyfill = function (e) {
        e || (e = o), e.requestAnimationFrame = i, e.cancelAnimationFrame = l;
      };
    }).call(this, n(19));
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function (e, t, n) {
      for (var r in t) {
        if (Object.prototype.hasOwnProperty.call(t, r)) {
          if (0 !== n[r]) return !1;
          var o = "number" === typeof t[r] ? t[r] : t[r].val;
          if (e[r] !== o) return !1;
        }
      }

      return !0;
    }, e.exports = t["default"];
  }, function (e, t, n) {
    e.exports = n(21)();
  }, function (e, t, n) {
    e.exports = {
      icon: "styles_icon__1epsX",
      "icon--close": "styles_icon--close__3g05n",
      "icon--launcher": "styles_icon--launcher__3kzjN"
    };
  }, function (e, t, n) {
    e.exports = {
      icon: "styles_icon__1Edfi",
      "icon--close": "styles_icon--close__28eh-",
      "icon--launcher": "styles_icon--launcher__3lXwk"
    };
  }, function (e, t, n) {
    e.exports = {
      button: "styles_button__15aTq"
    };
  }, function (e, t) {
    var n,
        r,
        o = e.exports = {};

    function a() {
      throw new Error("setTimeout has not been defined");
    }

    function u() {
      throw new Error("clearTimeout has not been defined");
    }

    function i(e) {
      if (n === setTimeout) return setTimeout(e, 0);
      if ((n === a || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

      try {
        return n(e, 0);
      } catch (t) {
        try {
          return n.call(null, e, 0);
        } catch (t) {
          return n.call(this, e, 0);
        }
      }
    }

    !function () {
      try {
        n = "function" === typeof setTimeout ? setTimeout : a;
      } catch (e) {
        n = a;
      }

      try {
        r = "function" === typeof clearTimeout ? clearTimeout : u;
      } catch (e) {
        r = u;
      }
    }();
    var l,
        c = [],
        s = !1,
        f = -1;

    function p() {
      s && l && (s = !1, l.length ? c = l.concat(c) : f = -1, c.length && y());
    }

    function y() {
      if (!s) {
        var e = i(p);
        s = !0;

        for (var t = c.length; t;) {
          for (l = c, c = []; ++f < t;) {
            l && l[f].run();
          }

          f = -1, t = c.length;
        }

        l = null, s = !1, function (e) {
          if (r === clearTimeout) return clearTimeout(e);
          if ((r === u || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

          try {
            r(e);
          } catch (t) {
            try {
              return r.call(null, e);
            } catch (t) {
              return r.call(this, e);
            }
          }
        }(e);
      }
    }

    function d(e, t) {
      this.fun = e, this.array = t;
    }

    function m() {}

    o.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      c.push(new d(e, t)), 1 !== c.length || s || i(y);
    }, d.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = m, o.addListener = m, o.once = m, o.off = m, o.removeListener = m, o.removeAllListeners = m, o.emit = m, o.prependListener = m, o.prependOnceListener = m, o.listeners = function (e) {
      return [];
    }, o.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, o.cwd = function () {
      return "/";
    }, o.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, o.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = {
      noWobble: {
        stiffness: 170,
        damping: 26
      },
      gentle: {
        stiffness: 120,
        damping: 14
      },
      wobbly: {
        stiffness: 180,
        damping: 12
      },
      stiff: {
        stiffness: 210,
        damping: 20
      }
    }, e.exports = t["default"];
  }, function (e, t, n) {
    var r;
    !function () {
      "use strict";

      var n = {}.hasOwnProperty;

      function o() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var r = arguments[t];

          if (r) {
            var a = typeof r;
            if ("string" === a || "number" === a) e.push(r);else if (Array.isArray(r) && r.length) {
              var u = o.apply(null, r);
              u && e.push(u);
            } else if ("object" === a) for (var i in r) {
              n.call(r, i) && r[i] && e.push(i);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (o["default"] = o, e.exports = o) : void 0 === (r = function () {
        return o;
      }.apply(t, [])) || (e.exports = r);
    }();
  }, function (e, t, n) {
    e.exports = n(28);
  }, function (e, t, n) {
    "use strict";

    var r = n(17),
        o = "function" === typeof Symbol && Symbol["for"],
        a = o ? Symbol["for"]("react.element") : 60103,
        u = o ? Symbol["for"]("react.portal") : 60106,
        i = o ? Symbol["for"]("react.fragment") : 60107,
        l = o ? Symbol["for"]("react.strict_mode") : 60108,
        c = o ? Symbol["for"]("react.profiler") : 60114,
        s = o ? Symbol["for"]("react.provider") : 60109,
        f = o ? Symbol["for"]("react.context") : 60110,
        p = o ? Symbol["for"]("react.forward_ref") : 60112,
        y = o ? Symbol["for"]("react.suspense") : 60113,
        d = o ? Symbol["for"]("react.memo") : 60115,
        m = o ? Symbol["for"]("react.lazy") : 60116,
        h = "function" === typeof Symbol && Symbol.iterator;

    function v(e) {
      for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) {
        t += "&args[]=" + encodeURIComponent(arguments[n]);
      }

      return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }

    var b = {
      isMounted: function isMounted() {
        return !1;
      },
      enqueueForceUpdate: function enqueueForceUpdate() {},
      enqueueReplaceState: function enqueueReplaceState() {},
      enqueueSetState: function enqueueSetState() {}
    },
        g = {};

    function S(e, t, n) {
      this.props = e, this.context = t, this.refs = g, this.updater = n || b;
    }

    function w() {}

    function O(e, t, n) {
      this.props = e, this.context = t, this.refs = g, this.updater = n || b;
    }

    S.prototype.isReactComponent = {}, S.prototype.setState = function (e, t) {
      if ("object" !== typeof e && "function" !== typeof e && null != e) throw Error(v(85));
      this.updater.enqueueSetState(this, e, t, "setState");
    }, S.prototype.forceUpdate = function (e) {
      this.updater.enqueueForceUpdate(this, e, "forceUpdate");
    }, w.prototype = S.prototype;

    var _ = O.prototype = new w();

    _.constructor = O, r(_, S.prototype), _.isPureReactComponent = !0;
    var T = {
      current: null
    },
        j = Object.prototype.hasOwnProperty,
        P = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };

    function I(e, t, n) {
      var r,
          o = {},
          u = null,
          i = null;
      if (null != t) for (r in void 0 !== t.ref && (i = t.ref), void 0 !== t.key && (u = "" + t.key), t) {
        j.call(t, r) && !P.hasOwnProperty(r) && (o[r] = t[r]);
      }
      var l = arguments.length - 2;
      if (1 === l) o.children = n;else if (1 < l) {
        for (var c = Array(l), s = 0; s < l; s++) {
          c[s] = arguments[s + 2];
        }

        o.children = c;
      }
      if (e && e.defaultProps) for (r in l = e.defaultProps) {
        void 0 === o[r] && (o[r] = l[r]);
      }
      return {
        $$typeof: a,
        type: e,
        key: u,
        ref: i,
        props: o,
        _owner: T.current
      };
    }

    function k(e) {
      return "object" === typeof e && null !== e && e.$$typeof === a;
    }

    var x = /\/+/g,
        E = [];

    function R(e, t, n, r) {
      if (E.length) {
        var o = E.pop();
        return o.result = e, o.keyPrefix = t, o.func = n, o.context = r, o.count = 0, o;
      }

      return {
        result: e,
        keyPrefix: t,
        func: n,
        context: r,
        count: 0
      };
    }

    function M(e) {
      e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > E.length && E.push(e);
    }

    function D(e, t, n) {
      return null == e ? 0 : function e(t, n, r, o) {
        var i = typeof t;
        "undefined" !== i && "boolean" !== i || (t = null);
        var l = !1;
        if (null === t) l = !0;else switch (i) {
          case "string":
          case "number":
            l = !0;
            break;

          case "object":
            switch (t.$$typeof) {
              case a:
              case u:
                l = !0;
            }

        }
        if (l) return r(o, t, "" === n ? "." + C(t, 0) : n), 1;
        if (l = 0, n = "" === n ? "." : n + ":", Array.isArray(t)) for (var c = 0; c < t.length; c++) {
          var s = n + C(i = t[c], c);
          l += e(i, s, r, o);
        } else if (null === t || "object" !== typeof t ? s = null : s = "function" === typeof (s = h && t[h] || t["@@iterator"]) ? s : null, "function" === typeof s) for (t = s.call(t), c = 0; !(i = t.next()).done;) {
          l += e(i = i.value, s = n + C(i, c++), r, o);
        } else if ("object" === i) throw r = "" + t, Error(v(31, "[object Object]" === r ? "object with keys {" + Object.keys(t).join(", ") + "}" : r, ""));
        return l;
      }(e, "", t, n);
    }

    function C(e, t) {
      return "object" === typeof e && null !== e && null != e.key ? function (e) {
        var t = {
          "=": "=0",
          ":": "=2"
        };
        return "$" + ("" + e).replace(/[=:]/g, function (e) {
          return t[e];
        });
      }(e.key) : t.toString(36);
    }

    function A(e, t) {
      e.func.call(e.context, t, e.count++);
    }

    function V(e, t, n) {
      var r = e.result,
          o = e.keyPrefix;
      e = e.func.call(e.context, t, e.count++), Array.isArray(e) ? N(e, r, n, function (e) {
        return e;
      }) : null != e && (k(e) && (e = function (e, t) {
        return {
          $$typeof: a,
          type: e.type,
          key: t,
          ref: e.ref,
          props: e.props,
          _owner: e._owner
        };
      }(e, o + (!e.key || t && t.key === e.key ? "" : ("" + e.key).replace(x, "$&/") + "/") + n)), r.push(e));
    }

    function N(e, t, n, r, o) {
      var a = "";
      null != n && (a = ("" + n).replace(x, "$&/") + "/"), D(e, V, t = R(t, a, r, o)), M(t);
    }

    var q = {
      current: null
    };

    function L() {
      var e = q.current;
      if (null === e) throw Error(v(321));
      return e;
    }

    var $ = {
      ReactCurrentDispatcher: q,
      ReactCurrentBatchConfig: {
        suspense: null
      },
      ReactCurrentOwner: T,
      IsSomeRendererActing: {
        current: !1
      },
      assign: r
    };
    t.Children = {
      map: function map(e, t, n) {
        if (null == e) return e;
        var r = [];
        return N(e, r, null, t, n), r;
      },
      forEach: function forEach(e, t, n) {
        if (null == e) return e;
        D(e, A, t = R(null, null, t, n)), M(t);
      },
      count: function count(e) {
        return D(e, function () {
          return null;
        }, null);
      },
      toArray: function toArray(e) {
        var t = [];
        return N(e, t, null, function (e) {
          return e;
        }), t;
      },
      only: function only(e) {
        if (!k(e)) throw Error(v(143));
        return e;
      }
    }, t.Component = S, t.Fragment = i, t.Profiler = c, t.PureComponent = O, t.StrictMode = l, t.Suspense = y, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $, t.cloneElement = function (e, t, n) {
      if (null === e || void 0 === e) throw Error(v(267, e));
      var o = r({}, e.props),
          u = e.key,
          i = e.ref,
          l = e._owner;

      if (null != t) {
        if (void 0 !== t.ref && (i = t.ref, l = T.current), void 0 !== t.key && (u = "" + t.key), e.type && e.type.defaultProps) var c = e.type.defaultProps;

        for (s in t) {
          j.call(t, s) && !P.hasOwnProperty(s) && (o[s] = void 0 === t[s] && void 0 !== c ? c[s] : t[s]);
        }
      }

      var s = arguments.length - 2;
      if (1 === s) o.children = n;else if (1 < s) {
        c = Array(s);

        for (var f = 0; f < s; f++) {
          c[f] = arguments[f + 2];
        }

        o.children = c;
      }
      return {
        $$typeof: a,
        type: e.type,
        key: u,
        ref: i,
        props: o,
        _owner: l
      };
    }, t.createContext = function (e, t) {
      return void 0 === t && (t = null), (e = {
        $$typeof: f,
        _calculateChangedBits: t,
        _currentValue: e,
        _currentValue2: e,
        _threadCount: 0,
        Provider: null,
        Consumer: null
      }).Provider = {
        $$typeof: s,
        _context: e
      }, e.Consumer = e;
    }, t.createElement = I, t.createFactory = function (e) {
      var t = I.bind(null, e);
      return t.type = e, t;
    }, t.createRef = function () {
      return {
        current: null
      };
    }, t.forwardRef = function (e) {
      return {
        $$typeof: p,
        render: e
      };
    }, t.isValidElement = k, t.lazy = function (e) {
      return {
        $$typeof: m,
        _ctor: e,
        _status: -1,
        _result: null
      };
    }, t.memo = function (e, t) {
      return {
        $$typeof: d,
        type: e,
        compare: void 0 === t ? null : t
      };
    }, t.useCallback = function (e, t) {
      return L().useCallback(e, t);
    }, t.useContext = function (e, t) {
      return L().useContext(e, t);
    }, t.useDebugValue = function () {}, t.useEffect = function (e, t) {
      return L().useEffect(e, t);
    }, t.useImperativeHandle = function (e, t, n) {
      return L().useImperativeHandle(e, t, n);
    }, t.useLayoutEffect = function (e, t) {
      return L().useLayoutEffect(e, t);
    }, t.useMemo = function (e, t) {
      return L().useMemo(e, t);
    }, t.useReducer = function (e, t, n) {
      return L().useReducer(e, t, n);
    }, t.useRef = function (e) {
      return L().useRef(e);
    }, t.useState = function (e) {
      return L().useState(e);
    }, t.version = "16.14.0";
  }, function (e, t, n) {
    "use strict";

    var r = Object.getOwnPropertySymbols,
        o = Object.prototype.hasOwnProperty,
        a = Object.prototype.propertyIsEnumerable;

    function u(e) {
      if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(e);
    }

    e.exports = function () {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

        for (var t = {}, n = 0; n < 10; n++) {
          t["_" + String.fromCharCode(n)] = n;
        }

        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
          return t[e];
        }).join("")) return !1;
        var r = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          r[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
      } catch (o) {
        return !1;
      }
    }() ? Object.assign : function (e, t) {
      for (var n, i, l = u(e), c = 1; c < arguments.length; c++) {
        for (var s in n = Object(arguments[c])) {
          o.call(n, s) && (l[s] = n[s]);
        }

        if (r) {
          i = r(n);

          for (var f = 0; f < i.length; f++) {
            a.call(n, i[f]) && (l[i[f]] = n[i[f]]);
          }
        }
      }

      return l;
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        o = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function a(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var u = a(n(3)),
        i = a(n(2)),
        l = a(n(4)),
        c = a(n(5)),
        s = a(n(6)),
        f = a(n(7)),
        p = a(n(0)),
        y = a(n(8)),
        d = function (e) {
      function t(n) {
        var o = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), e.call(this, n), this.wasAnimating = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyle = null, this.clearUnreadPropStyle = function (e) {
          var t = !1,
              n = o.state,
              a = n.currentStyle,
              u = n.currentVelocity,
              i = n.lastIdealStyle,
              l = n.lastIdealVelocity;

          for (var c in e) {
            if (Object.prototype.hasOwnProperty.call(e, c)) {
              var s = e[c];
              "number" === typeof s && (t || (t = !0, a = r({}, a), u = r({}, u), i = r({}, i), l = r({}, l)), a[c] = s, u[c] = 0, i[c] = s, l[c] = 0);
            }
          }

          t && o.setState({
            currentStyle: a,
            currentVelocity: u,
            lastIdealStyle: i,
            lastIdealVelocity: l
          });
        }, this.startAnimationIfNecessary = function () {
          o.animationID = s["default"](function (e) {
            var t = o.props.style;
            if (f["default"](o.state.currentStyle, t, o.state.currentVelocity)) return o.wasAnimating && o.props.onRest && o.props.onRest(), o.animationID = null, o.wasAnimating = !1, void (o.accumulatedTime = 0);
            o.wasAnimating = !0;
            var n = e || c["default"](),
                r = n - o.prevTime;
            if (o.prevTime = n, o.accumulatedTime = o.accumulatedTime + r, o.accumulatedTime > 1e3 / 60 * 10 && (o.accumulatedTime = 0), 0 === o.accumulatedTime) return o.animationID = null, void o.startAnimationIfNecessary();
            var a = (o.accumulatedTime - Math.floor(o.accumulatedTime / (1e3 / 60)) * (1e3 / 60)) / (1e3 / 60),
                u = Math.floor(o.accumulatedTime / (1e3 / 60)),
                i = {},
                s = {},
                p = {},
                y = {};

            for (var d in t) {
              if (Object.prototype.hasOwnProperty.call(t, d)) {
                var m = t[d];
                if ("number" === typeof m) p[d] = m, y[d] = 0, i[d] = m, s[d] = 0;else {
                  for (var h = o.state.lastIdealStyle[d], v = o.state.lastIdealVelocity[d], b = 0; b < u; b++) {
                    var g = l["default"](1e3 / 60 / 1e3, h, v, m.val, m.stiffness, m.damping, m.precision);
                    h = g[0], v = g[1];
                  }

                  var S = l["default"](1e3 / 60 / 1e3, h, v, m.val, m.stiffness, m.damping, m.precision),
                      w = S[0],
                      O = S[1];
                  p[d] = h + (w - h) * a, y[d] = v + (O - v) * a, i[d] = h, s[d] = v;
                }
              }
            }

            o.animationID = null, o.accumulatedTime -= u * (1e3 / 60), o.setState({
              currentStyle: p,
              currentVelocity: y,
              lastIdealStyle: i,
              lastIdealVelocity: s
            }), o.unreadPropStyle = null, o.startAnimationIfNecessary();
          });
        }, this.state = this.defaultState();
      }

      return function (e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), o(t, null, [{
        key: "propTypes",
        value: {
          defaultStyle: y["default"].objectOf(y["default"].number),
          style: y["default"].objectOf(y["default"].oneOfType([y["default"].number, y["default"].object])).isRequired,
          children: y["default"].func.isRequired,
          onRest: y["default"].func
        },
        enumerable: !0
      }]), t.prototype.defaultState = function () {
        var e = this.props,
            t = e.defaultStyle,
            n = e.style,
            r = t || i["default"](n),
            o = u["default"](r);
        return {
          currentStyle: r,
          currentVelocity: o,
          lastIdealStyle: r,
          lastIdealVelocity: o
        };
      }, t.prototype.componentDidMount = function () {
        this.prevTime = c["default"](), this.startAnimationIfNecessary();
      }, t.prototype.componentWillReceiveProps = function (e) {
        null != this.unreadPropStyle && this.clearUnreadPropStyle(this.unreadPropStyle), this.unreadPropStyle = e.style, null == this.animationID && (this.prevTime = c["default"](), this.startAnimationIfNecessary());
      }, t.prototype.componentWillUnmount = function () {
        null != this.animationID && (s["default"].cancel(this.animationID), this.animationID = null);
      }, t.prototype.render = function () {
        var e = this.props.children(this.state.currentStyle);
        return e && p["default"].Children.only(e);
      }, t;
    }(p["default"].Component);

    t["default"] = d, e.exports = t["default"];
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (r) {
      "object" === typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    (function (t) {
      (function () {
        var n, r, o, a, u, i;
        "undefined" !== typeof performance && null !== performance && performance.now ? e.exports = function () {
          return performance.now();
        } : "undefined" !== typeof t && null !== t && t.hrtime ? (e.exports = function () {
          return (n() - u) / 1e6;
        }, r = t.hrtime, a = (n = function n() {
          var e;
          return 1e9 * (e = r())[0] + e[1];
        })(), i = 1e9 * t.uptime(), u = a - i) : Date.now ? (e.exports = function () {
          return Date.now() - o;
        }, o = Date.now()) : (e.exports = function () {
          return new Date().getTime() - o;
        }, o = new Date().getTime());
      }).call(this);
    }).call(this, n(12));
  }, function (e, t, n) {
    "use strict";

    var r = n(22);

    function o() {}

    function a() {}

    a.resetWarningCache = o, e.exports = function () {
      function e(e, t, n, o, a, u) {
        if (u !== r) {
          var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw i.name = "Invariant Violation", i;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: a,
        resetWarningCache: o
      };
      return n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        o = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function a(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var u = a(n(3)),
        i = a(n(2)),
        l = a(n(4)),
        c = a(n(5)),
        s = a(n(6)),
        f = a(n(7)),
        p = a(n(0)),
        y = a(n(8));

    var d = function (e) {
      function t(n) {
        var o = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), e.call(this, n), this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (e) {
          for (var t = o.state, n = t.currentStyles, a = t.currentVelocities, u = t.lastIdealStyles, i = t.lastIdealVelocities, l = !1, c = 0; c < e.length; c++) {
            var s = e[c],
                f = !1;

            for (var p in s) {
              if (Object.prototype.hasOwnProperty.call(s, p)) {
                var y = s[p];
                "number" === typeof y && (f || (f = !0, l = !0, n[c] = r({}, n[c]), a[c] = r({}, a[c]), u[c] = r({}, u[c]), i[c] = r({}, i[c])), n[c][p] = y, a[c][p] = 0, u[c][p] = y, i[c][p] = 0);
              }
            }
          }

          l && o.setState({
            currentStyles: n,
            currentVelocities: a,
            lastIdealStyles: u,
            lastIdealVelocities: i
          });
        }, this.startAnimationIfNecessary = function () {
          o.animationID = s["default"](function (e) {
            var t = o.props.styles(o.state.lastIdealStyles);
            if (function (e, t, n) {
              for (var r = 0; r < e.length; r++) {
                if (!f["default"](e[r], t[r], n[r])) return !1;
              }

              return !0;
            }(o.state.currentStyles, t, o.state.currentVelocities)) return o.animationID = null, void (o.accumulatedTime = 0);
            var n = e || c["default"](),
                r = n - o.prevTime;
            if (o.prevTime = n, o.accumulatedTime = o.accumulatedTime + r, o.accumulatedTime > 1e3 / 60 * 10 && (o.accumulatedTime = 0), 0 === o.accumulatedTime) return o.animationID = null, void o.startAnimationIfNecessary();

            for (var a = (o.accumulatedTime - Math.floor(o.accumulatedTime / (1e3 / 60)) * (1e3 / 60)) / (1e3 / 60), u = Math.floor(o.accumulatedTime / (1e3 / 60)), i = [], s = [], p = [], y = [], d = 0; d < t.length; d++) {
              var m = t[d],
                  h = {},
                  v = {},
                  b = {},
                  g = {};

              for (var S in m) {
                if (Object.prototype.hasOwnProperty.call(m, S)) {
                  var w = m[S];
                  if ("number" === typeof w) h[S] = w, v[S] = 0, b[S] = w, g[S] = 0;else {
                    for (var O = o.state.lastIdealStyles[d][S], _ = o.state.lastIdealVelocities[d][S], T = 0; T < u; T++) {
                      var j = l["default"](1e3 / 60 / 1e3, O, _, w.val, w.stiffness, w.damping, w.precision);
                      O = j[0], _ = j[1];
                    }

                    var P = l["default"](1e3 / 60 / 1e3, O, _, w.val, w.stiffness, w.damping, w.precision),
                        I = P[0],
                        k = P[1];
                    h[S] = O + (I - O) * a, v[S] = _ + (k - _) * a, b[S] = O, g[S] = _;
                  }
                }
              }

              p[d] = h, y[d] = v, i[d] = b, s[d] = g;
            }

            o.animationID = null, o.accumulatedTime -= u * (1e3 / 60), o.setState({
              currentStyles: p,
              currentVelocities: y,
              lastIdealStyles: i,
              lastIdealVelocities: s
            }), o.unreadPropStyles = null, o.startAnimationIfNecessary();
          });
        }, this.state = this.defaultState();
      }

      return function (e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), o(t, null, [{
        key: "propTypes",
        value: {
          defaultStyles: y["default"].arrayOf(y["default"].objectOf(y["default"].number)),
          styles: y["default"].func.isRequired,
          children: y["default"].func.isRequired
        },
        enumerable: !0
      }]), t.prototype.defaultState = function () {
        var e = this.props,
            t = e.defaultStyles,
            n = e.styles,
            r = t || n().map(i["default"]),
            o = r.map(function (e) {
          return u["default"](e);
        });
        return {
          currentStyles: r,
          currentVelocities: o,
          lastIdealStyles: r,
          lastIdealVelocities: o
        };
      }, t.prototype.componentDidMount = function () {
        this.prevTime = c["default"](), this.startAnimationIfNecessary();
      }, t.prototype.componentWillReceiveProps = function (e) {
        null != this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles), this.unreadPropStyles = e.styles(this.state.lastIdealStyles), null == this.animationID && (this.prevTime = c["default"](), this.startAnimationIfNecessary());
      }, t.prototype.componentWillUnmount = function () {
        null != this.animationID && (s["default"].cancel(this.animationID), this.animationID = null);
      }, t.prototype.render = function () {
        var e = this.props.children(this.state.currentStyles);
        return e && p["default"].Children.only(e);
      }, t;
    }(p["default"].Component);

    t["default"] = d, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        o = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function a(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var u = a(n(3)),
        i = a(n(2)),
        l = a(n(4)),
        c = a(n(25)),
        s = a(n(5)),
        f = a(n(6)),
        p = a(n(7)),
        y = a(n(0)),
        d = a(n(8));

    function m(e, t, n) {
      var r = t;
      return null == r ? e.map(function (e, t) {
        return {
          key: e.key,
          data: e.data,
          style: n[t]
        };
      }) : e.map(function (e, t) {
        for (var o = 0; o < r.length; o++) {
          if (r[o].key === e.key) return {
            key: r[o].key,
            data: r[o].data,
            style: n[t]
          };
        }

        return {
          key: e.key,
          data: e.data,
          style: n[t]
        };
      });
    }

    function h(e, t, n, r, o, a, i, l, s) {
      for (var f = c["default"](r, o, function (e, r) {
        var o = t(r);
        return null == o || p["default"](a[e], o, i[e]) ? (n({
          key: r.key,
          data: r.data
        }), null) : {
          key: r.key,
          data: r.data,
          style: o
        };
      }), y = [], d = [], m = [], h = [], v = 0; v < f.length; v++) {
        for (var b = f[v], g = null, S = 0; S < r.length; S++) {
          if (r[S].key === b.key) {
            g = S;
            break;
          }
        }

        if (null == g) {
          var w = e(b);
          y[v] = w, m[v] = w;
          var O = u["default"](b.style);
          d[v] = O, h[v] = O;
        } else y[v] = a[g], m[v] = l[g], d[v] = i[g], h[v] = s[g];
      }

      return [f, y, d, m, h];
    }

    var v = function (e) {
      function t(n) {
        var o = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), e.call(this, n), this.unmounting = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (e) {
          for (var t = h(o.props.willEnter, o.props.willLeave, o.props.didLeave, o.state.mergedPropsStyles, e, o.state.currentStyles, o.state.currentVelocities, o.state.lastIdealStyles, o.state.lastIdealVelocities), n = t[0], a = t[1], u = t[2], i = t[3], l = t[4], c = 0; c < e.length; c++) {
            var s = e[c].style,
                f = !1;

            for (var p in s) {
              if (Object.prototype.hasOwnProperty.call(s, p)) {
                var y = s[p];
                "number" === typeof y && (f || (f = !0, a[c] = r({}, a[c]), u[c] = r({}, u[c]), i[c] = r({}, i[c]), l[c] = r({}, l[c]), n[c] = {
                  key: n[c].key,
                  data: n[c].data,
                  style: r({}, n[c].style)
                }), a[c][p] = y, u[c][p] = 0, i[c][p] = y, l[c][p] = 0, n[c].style[p] = y);
              }
            }
          }

          o.setState({
            currentStyles: a,
            currentVelocities: u,
            mergedPropsStyles: n,
            lastIdealStyles: i,
            lastIdealVelocities: l
          });
        }, this.startAnimationIfNecessary = function () {
          o.unmounting || (o.animationID = f["default"](function (e) {
            if (!o.unmounting) {
              var t = o.props.styles,
                  n = "function" === typeof t ? t(m(o.state.mergedPropsStyles, o.unreadPropStyles, o.state.lastIdealStyles)) : t;
              if (function (e, t, n, r) {
                if (r.length !== t.length) return !1;

                for (var o = 0; o < r.length; o++) {
                  if (r[o].key !== t[o].key) return !1;
                }

                for (o = 0; o < r.length; o++) {
                  if (!p["default"](e[o], t[o].style, n[o])) return !1;
                }

                return !0;
              }(o.state.currentStyles, n, o.state.currentVelocities, o.state.mergedPropsStyles)) return o.animationID = null, void (o.accumulatedTime = 0);
              var r = e || s["default"](),
                  a = r - o.prevTime;
              if (o.prevTime = r, o.accumulatedTime = o.accumulatedTime + a, o.accumulatedTime > 1e3 / 60 * 10 && (o.accumulatedTime = 0), 0 === o.accumulatedTime) return o.animationID = null, void o.startAnimationIfNecessary();

              for (var u = (o.accumulatedTime - Math.floor(o.accumulatedTime / (1e3 / 60)) * (1e3 / 60)) / (1e3 / 60), i = Math.floor(o.accumulatedTime / (1e3 / 60)), c = h(o.props.willEnter, o.props.willLeave, o.props.didLeave, o.state.mergedPropsStyles, n, o.state.currentStyles, o.state.currentVelocities, o.state.lastIdealStyles, o.state.lastIdealVelocities), f = c[0], y = c[1], d = c[2], v = c[3], b = c[4], g = 0; g < f.length; g++) {
                var S = f[g].style,
                    w = {},
                    O = {},
                    _ = {},
                    T = {};

                for (var j in S) {
                  if (Object.prototype.hasOwnProperty.call(S, j)) {
                    var P = S[j];
                    if ("number" === typeof P) w[j] = P, O[j] = 0, _[j] = P, T[j] = 0;else {
                      for (var I = v[g][j], k = b[g][j], x = 0; x < i; x++) {
                        var E = l["default"](1e3 / 60 / 1e3, I, k, P.val, P.stiffness, P.damping, P.precision);
                        I = E[0], k = E[1];
                      }

                      var R = l["default"](1e3 / 60 / 1e3, I, k, P.val, P.stiffness, P.damping, P.precision),
                          M = R[0],
                          D = R[1];
                      w[j] = I + (M - I) * u, O[j] = k + (D - k) * u, _[j] = I, T[j] = k;
                    }
                  }
                }

                v[g] = _, b[g] = T, y[g] = w, d[g] = O;
              }

              o.animationID = null, o.accumulatedTime -= i * (1e3 / 60), o.setState({
                currentStyles: y,
                currentVelocities: d,
                lastIdealStyles: v,
                lastIdealVelocities: b,
                mergedPropsStyles: f
              }), o.unreadPropStyles = null, o.startAnimationIfNecessary();
            }
          }));
        }, this.state = this.defaultState();
      }

      return function (e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), o(t, null, [{
        key: "propTypes",
        value: {
          defaultStyles: d["default"].arrayOf(d["default"].shape({
            key: d["default"].string.isRequired,
            data: d["default"].any,
            style: d["default"].objectOf(d["default"].number).isRequired
          })),
          styles: d["default"].oneOfType([d["default"].func, d["default"].arrayOf(d["default"].shape({
            key: d["default"].string.isRequired,
            data: d["default"].any,
            style: d["default"].objectOf(d["default"].oneOfType([d["default"].number, d["default"].object])).isRequired
          }))]).isRequired,
          children: d["default"].func.isRequired,
          willEnter: d["default"].func,
          willLeave: d["default"].func,
          didLeave: d["default"].func
        },
        enumerable: !0
      }, {
        key: "defaultProps",
        value: {
          willEnter: function willEnter(e) {
            return i["default"](e.style);
          },
          willLeave: function willLeave() {
            return null;
          },
          didLeave: function didLeave() {}
        },
        enumerable: !0
      }]), t.prototype.defaultState = function () {
        var e = this.props,
            t = e.defaultStyles,
            n = e.styles,
            r = e.willEnter,
            o = e.willLeave,
            a = e.didLeave,
            l = "function" === typeof n ? n(t) : n,
            c = void 0;
        c = null == t ? l : t.map(function (e) {
          for (var t = 0; t < l.length; t++) {
            if (l[t].key === e.key) return l[t];
          }

          return e;
        });
        var s = null == t ? l.map(function (e) {
          return i["default"](e.style);
        }) : t.map(function (e) {
          return i["default"](e.style);
        }),
            f = null == t ? l.map(function (e) {
          return u["default"](e.style);
        }) : t.map(function (e) {
          return u["default"](e.style);
        }),
            p = h(r, o, a, c, l, s, f, s, f),
            y = p[0];
        return {
          currentStyles: p[1],
          currentVelocities: p[2],
          lastIdealStyles: p[3],
          lastIdealVelocities: p[4],
          mergedPropsStyles: y
        };
      }, t.prototype.componentDidMount = function () {
        this.prevTime = s["default"](), this.startAnimationIfNecessary();
      }, t.prototype.componentWillReceiveProps = function (e) {
        this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles);
        var t = e.styles;
        this.unreadPropStyles = "function" === typeof t ? t(m(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles)) : t, null == this.animationID && (this.prevTime = s["default"](), this.startAnimationIfNecessary());
      }, t.prototype.componentWillUnmount = function () {
        this.unmounting = !0, null != this.animationID && (f["default"].cancel(this.animationID), this.animationID = null);
      }, t.prototype.render = function () {
        var e = m(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles),
            t = this.props.children(e);
        return t && y["default"].Children.only(t);
      }, t;
    }(y["default"].Component);

    t["default"] = v, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function (e, t, n) {
      for (var r = {}, o = 0; o < e.length; o++) {
        r[e[o].key] = o;
      }

      var a = {};

      for (o = 0; o < t.length; o++) {
        a[t[o].key] = o;
      }

      var u = [];

      for (o = 0; o < t.length; o++) {
        u[o] = t[o];
      }

      for (o = 0; o < e.length; o++) {
        if (!Object.prototype.hasOwnProperty.call(a, e[o].key)) {
          var i = n(o, e[o]);
          null != i && u.push(i);
        }
      }

      return u.sort(function (e, n) {
        var o = a[e.key],
            u = a[n.key],
            i = r[e.key],
            l = r[n.key];
        if (null != o && null != u) return a[e.key] - a[n.key];
        if (null != i && null != l) return r[e.key] - r[n.key];

        if (null != o) {
          for (var c = 0; c < t.length; c++) {
            var s = t[c].key;

            if (Object.prototype.hasOwnProperty.call(r, s)) {
              if (o < a[s] && l > r[s]) return -1;
              if (o > a[s] && l < r[s]) return 1;
            }
          }

          return 1;
        }

        for (c = 0; c < t.length; c++) {
          s = t[c].key;

          if (Object.prototype.hasOwnProperty.call(r, s)) {
            if (u < a[s] && i > r[s]) return 1;
            if (u > a[s] && i < r[s]) return -1;
          }
        }

        return -1;
      });
    }, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    t["default"] = function (e, t) {
      return r({}, i, t, {
        val: e
      });
    };

    var o,
        a = n(13),
        u = (o = a) && o.__esModule ? o : {
      "default": o
    },
        i = r({}, u["default"].noWobble, {
      precision: .01
    });
    e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function () {
      0;
    };
    e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function a(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function u(e, t) {
      return (u = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function i(e) {
      return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function l() {
      if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" === typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }

    function c(e) {
      return (c = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function s(e, t) {
      return !t || "object" !== c(t) && "function" !== typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    n.r(t);

    var f = n(0),
        p = n.n(f),
        y = n(1),
        d = n(14),
        m = n.n(d),
        h = {
      "default": {
        stiffness: 330,
        damping: 20
      }
    },
        v = n(9),
        b = n.n(v),
        g = function g(e) {
      return p.a.createElement("svg", Object.assign({
        width: 36.85,
        height: 36.85,
        viewBox: "0 0 36.85 36.85"
      }, e), p.a.createElement("path", {
        fill: "#FFF",
        d: "M25.475 6.445H11.408c-5.647 0-10.284 4.584-10.284 10.286 0 3.835 2.13 7.192 5.222 8.95-.533 1.12-1.225 2.397-2.025 3.516-.746 1.013.213 2.347 1.386 2.025 3.836-1.013 7.354-2.982 9.325-4.209h10.442c5.649 0 10.285-4.583 10.285-10.282.001-5.702-4.635-10.286-10.284-10.286zM10.77 18.916a2.253 2.253 0 01-2.239-2.24 2.252 2.252 0 012.239-2.237 2.251 2.251 0 012.237 2.237 2.252 2.252 0 01-2.237 2.24zm7.673 0a2.252 2.252 0 01-2.238-2.24 2.25 2.25 0 012.238-2.237 2.252 2.252 0 012.238 2.237 2.253 2.253 0 01-2.238 2.24zm7.672 0a2.253 2.253 0 01-2.238-2.24 2.252 2.252 0 012.238-2.237 2.25 2.25 0 012.238 2.237 2.251 2.251 0 01-2.238 2.24z"
      }));
    },
        S = function S(e) {
      var t = e.active;
      return p.a.createElement(y.Motion, {
        defaultStyle: {
          opacity: 1,
          rotate: 0,
          scale: 1
        },
        style: {
          opacity: Object(y.spring)(t ? 0 : 1, h["default"]),
          rotate: Object(y.spring)(t ? 45 : 0, h["default"]),
          scale: Object(y.spring)(t ? 0 : 1, h["default"])
        }
      }, function (e) {
        return p.a.createElement(g, {
          alt: "Launcher Icon",
          className: "".concat(b.a.icon, " ").concat(b.a["icon--launcher"]),
          style: {
            opacity: e.opacity,
            transform: "\n            rotate(".concat(e.rotate, "deg)\n            scale(").concat(e.scale, ")\n            translate(-50%, -50%)\n          ")
          }
        });
      });
    },
        w = n(10),
        O = n.n(w),
        _ = function _(e) {
      return p.a.createElement("svg", Object.assign({
        width: 32,
        height: 32,
        viewBox: "290 380 32 32"
      }, e), p.a.createElement("path", {
        d: "M307.832 395.997l6.071-6.069a1.297 1.297 0 000-1.832 1.298 1.298 0 00-1.833 0l-6.071 6.07-6.069-6.07a1.295 1.295 0 10-1.832 1.832l6.07 6.069-6.07 6.071a1.293 1.293 0 000 1.83 1.3 1.3 0 00.906.385c.332 0 .664-.123.907-.385l6.088-6.069 6.071 6.069a1.3 1.3 0 00.907.385c.332 0 .663-.123.906-.385a1.291 1.291 0 000-1.83l-6.051-6.071z",
        fill: "#fff"
      }), p.a.createElement("path", {
        fill: "none",
        d: "M290 380h32v32h-32z"
      }));
    },
        T = function T(e) {
      var t = e.active;
      return p.a.createElement(y.Motion, {
        defaultStyle: {
          opacity: 0,
          rotate: -45,
          scale: 0
        },
        style: {
          opacity: Object(y.spring)(t ? 1 : 0, h["default"]),
          rotate: Object(y.spring)(t ? 0 : -45, h["default"]),
          scale: Object(y.spring)(t ? 1 : 0, h["default"])
        }
      }, function (e) {
        return p.a.createElement(_, {
          alt: "Close Icon",
          className: "".concat(O.a.icon, " ").concat(O.a["icon--close"]),
          style: {
            opacity: e.opacity,
            transform: "\n            rotate(".concat(e.rotate, "deg)\n            scale(").concat(e.scale, ")\n            translate(-50%, -50%)\n          ")
          }
        });
      });
    },
        j = n(11),
        P = n.n(j),
        I = function (e) {
      !function (e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && u(e, t);
      }(v, e);
      var t,
          n,
          c,
          f,
          d = (t = v, function () {
        var e,
            n = i(t);

        if (l()) {
          var r = i(this).constructor;
          e = Reflect.construct(n, arguments, r);
        } else e = n.apply(this, arguments);

        return s(this, e);
      });

      function v() {
        var e;
        o(this, v);

        for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
          n[r] = arguments[r];
        }

        return (e = d.call.apply(d, [this].concat(n))).state = {
          stable: !1
        }, e.handleRest = function () {
          e.setState({
            stable: !0
          });
        }, e;
      }

      return n = v, (c = [{
        key: "componentWillUnmount",
        value: function value() {
          this.setState({
            stable: !1
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e,
              t = this.props,
              n = t.active,
              o = t.className,
              a = t.onClick,
              u = m()((r(e = {}, P.a.button, !0), r(e, P.a["button--active"], n), e), o);
          return p.a.createElement(y.Motion, {
            defaultStyle: {
              opacity: 0,
              scale: 0
            },
            style: {
              opacity: Object(y.spring)(1, h["default"]),
              scale: Object(y.spring)(1, h["default"])
            },
            onRest: this.handleRest
          }, function (e) {
            return p.a.createElement("button", {
              className: u,
              onClick: a,
              style: {
                opacity: e.opacity,
                transform: "scale(".concat(e.scale, ")")
              }
            }, p.a.createElement(S, {
              active: n
            }), p.a.createElement(T, {
              active: n
            }));
          });
        }
      }]) && a(n.prototype, c), f && a(n, f), v;
    }(f.Component);

    t["default"] = I;
  }])["default"];
});